module.exports = __webpack_public_path__ + "img/5.ee417cb2.png";